<template>
  <article v-if="question !== null" class="flow-group">
    <h3>
      <span v-html="question.label" />
      <tooltip :content="question.tooltip" />
    </h3>
    <div class="control">
      <Field
        v-model="model.value"
        v-slot="{ field }"
        :name="questionName"
        :rules="question.type === 2 ? 'required|min:3' : 'required'"
        label="Svaret"
      >
        <api-search
          v-if="question.type === 2"
          v-bind="field"
          :api="question.apiPath"
          :auto-select="true"
          :skip-question-label="question.skipQuestionLabel"
          :skip-question-field-text="question.skipQuestionFieldText"
          :placeholder="question.placeholder"
          :data-test-question-type="'search-' + indexKey"
          label="label"
        />
        <radio-buttons
          v-if="question.type === 1"
          v-bind="field"
          :options="question.options"
          :data-test-question-type="'radio-' + indexKey"
        />
        <vue-select
          v-if="question.type === 3"
          :options="question.options"
          v-bind="field"
          :searchable="false"
          :placeholder="question.placeholder"
          :data-test-question-type="'select-' + indexKey"
        />
      </Field>
      <div class="push-up">
        <ValidationError
          :name="questionName.toString()"
          :overrides="{ required: decodeHtml(validationText) }"
        />
      </div>
    </div>
  </article>
</template>

<script lang="ts">
import RadioButtons from './RadioButtons.vue';
import ApiSearch from '@/components/UI/ApiSearch.vue';
import ValidationError from '@/components/UI/ValidationError.vue';
import Tooltip from '@/components/UI/Tooltip.vue';
import { defineComponent } from 'vue';
import Utility from '@/common/UtilityFunctions';
import { FormContextKey } from 'vee-validate';
import { inject } from 'vue';

export default defineComponent({
  name: 'EligibilityQuestion',
  components: {
    ApiSearch,
    RadioButtons,
    ValidationError,
    Tooltip
  },
  setup() {
    return { form: inject(FormContextKey, undefined) };
  },
  watch: {
    'model.value': function (newVal) {
      //this.form?.validate();
    }
  },
  props: {
    question: {
      type: Object,
      default() {
        return null;
      }
    },
    indexKey: {
      type: Number,
      default() {
        return null;
      }
    },
    validationText: {
      type: String,
      default() {
        return 'Skal udfyldes';
      }
    }
  },
  data() {
    return {
      model: this.question
    };
  },
  computed: {
    questionName(): String {
      return 'question-' + this.indexKey;
    }
  },
  methods: {
    decodeHtml: Utility.decodeHtml
  }
});
</script>
